import { t } from "i18next";
import { RatingStars, TableItemStatus } from "ui";

import { OrderStatus } from "../../../constants";
import { ExpeditionBadge } from "../../ExpeditionBadge";
import { OrderUnpackingStatusLabel } from "../../OrderUnpackingStatusLabel";
import { PersonalOrderBadge } from "../../PersonalOrderBadge";
import { OrderStatusCellProps } from "../OrdersTable.types";

import styles from "../OrdersTable.module.scss";

export const OrderStatusCell = ({
  order,
  statusesList,
  activeStatusIndex
}: OrderStatusCellProps) => {
  return (
    <div className={styles.ordersTable_statusCell}>
      <TableItemStatus
        activeStatusIndex={activeStatusIndex}
        statusesList={statusesList}
        fullWidth
      />
      {order.isExpedition && <ExpeditionBadge />}
      {order.isPersonalOrder && <PersonalOrderBadge />}
      {!!order.feedbackGrade && (
        <RatingStars
          grade={order.feedbackGrade}
          size={16}
          className={styles.ordersTable_feedbackStars}
        />
      )}
      <OrderUnpackingStatusLabel
        unpackingStatus={order.unpackingStatus}
        quantityOfItemsToUnpack={order.quantityOfItemsToUnpack}
        unpackedAt={order.unpackedAt}
      />
      {order.status === OrderStatus.Collecting && order.hasUnavailableItems && (
        <div className={styles.ordersTable_unavailableItemsLabel}>
          {t("Has unavailable items")}
        </div>
      )}
    </div>
  );
};
